











































































import Vue, { PropType } from 'vue';

interface DataType {
  isShow: boolean;
}

export default Vue.extend({
  name: 'GChatBrandInfoSp',
  props: {
    brandLogoSrc: {
      type: String as PropType<string>,
      default: '',
    },
    brandName: {
      type: String as PropType<string>,
      default: '',
    },
    brandImageSrc: {
      type: String as PropType<string>,
      default: '',
    },
    company: {
      type: String as PropType<string>,
      default: '',
    },
    department: {
      type: String as PropType<string>,
      default: '',
    },
    name: {
      type: String as PropType<string>,
      default: '',
    },
    shop: {
      type: String as PropType<string>,
      default: '',
    },
    zip: {
      type: String as PropType<string>,
      default: '',
    },
    province: {
      type: String as PropType<string>,
      default: '',
    },
    city: {
      type: String as PropType<string>,
      default: '',
    },
    address: {
      type: String as PropType<string>,
      default: '',
    },
    building: {
      type: String as PropType<string>,
      default: '',
    },
    website: {
      type: String as PropType<string>,
      default: '',
    },
    introduction: {
      type: String as PropType<string>,
      default: '',
    },
    brandUrl: {
      type: String as PropType<string>,
      default: '',
    },
  },
  data(): DataType {
    return {
      isShow: false,
    };
  },
  methods: {
    toggleInfo() {
      this.isShow = !this.isShow;
    },
  },
});
